import { useState } from 'react';

import HelpModeDrawer from './HelpModeDrawer';
import HelpModeTrigger from './HelpModeTrigger';

type HelpModeProps = {
  className?: string;
};

const HelpMode = ({ className: triggerClassName }: HelpModeProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <HelpModeTrigger
        className={triggerClassName}
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
      />
      <HelpModeDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
};

export default HelpMode;
